import React, { useMemo } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// material-ui
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// project import
import MainCard from "components/MainCard";

dayjs.extend(utc);
dayjs.extend(timezone);

const StatsBlock = ({ data }) => {
  const theme = useTheme();
  const valueColor = "#008514";
  const titleColor = "#262626";
  const timezone = data?.timeConfig?.timezone || "UTC";
  const nextDeductionDate = useMemo(
    () => dayjs.unix(data.nextDeductionAt).tz(timezone),
    [data.nextDeductionAt, timezone],
  );

  return (
    <MainCard
      content={false}
      sx={{
        bgcolor: theme.palette.common.white,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "15px",
        overflow: "hidden",
        boxShadow: "none",
      }}
    >
      <Box sx={{ p: 3, px: 5 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Stack spacing={0}>
              <Typography
                variant='body2'
                sx={{ color: titleColor, fontSize: "14px", fontWeight: "bold" }}
              >
                Current Balance
              </Typography>
              <Typography
                sx={{
                  fontSize: "35px",
                  fontWeight: "bold",
                  color: valueColor,
                  lineHeight: 1.2,
                }}
              >
                {data.balance?.toLocaleString() || "-"}
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  color: "#373737",
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                Credits
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Stack spacing={0}>
              <Typography
                variant='body2'
                sx={{ color: titleColor, fontSize: "14px", fontWeight: "bold" }}
              >
                Daily Usage
              </Typography>
              <Typography
                sx={{
                  fontSize: "35px",
                  fontWeight: "bold",
                  color: valueColor,
                  lineHeight: 1.2,
                }}
              >
                {data.dailyUsage || "-"}
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  color: "#373737",
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                Credits / day
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Stack spacing={0}>
              <Typography
                variant='body2'
                sx={{ color: titleColor, fontSize: "14px", fontWeight: "bold" }}
              >
                Days Remaining
              </Typography>
              <Typography
                sx={{
                  fontSize: "35px",
                  fontWeight: "bold",
                  color: valueColor,
                  lineHeight: 1.2,
                }}
              >
                {data.remainingDays || "-"}
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  color: "#373737",
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                Days
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Stack spacing={0}>
              <Typography
                variant='body2'
                sx={{ color: titleColor, fontSize: "14px", fontWeight: "bold" }}
              >
                Next Deduction
              </Typography>
              <Typography
                sx={{
                  fontSize: "35px",
                  fontWeight: "bold",
                  color: valueColor,
                  lineHeight: 1.2,
                }}
              >
                {data.nextDeduction?.toLocaleString() || "-"}
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  color: "#373737",
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                {data.nextDeductionAt
                  ? nextDeductionDate.format("YYYY-MM-DD")
                  : "-"}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </MainCard>
  );
};

export default StatsBlock;
